module.exports = __webpack_public_path__ + "id.d47bdf72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/id.png
// module id = 2243
// module chunks = 0